// Regions and countries used across News, Trends, Keitaro, Statistics, Prompting
const REGIONS = [
  {
    label: 'Северная Америка',
    countries: [
      { code: 'CA', name: 'Канада' },
      { code: 'MX', name: 'Мексика' },
      { code: 'PA', name: 'Панама' },
      { code: 'TT', name: 'Тринидад и Тобаго' },
    ],
  },
  {
    label: 'Южная Америка',
    countries: [
      { code: 'AR', name: 'Аргентина' },
      { code: 'BR', name: 'Бразилия' },
      { code: 'CO', name: 'Колумбия' },
      { code: 'PE', name: 'Перу' },
      { code: 'CL', name: 'Чили' },
    ],
  },
  {
    label: 'Ближний Восток',
    countries: [
      { code: 'TR', name: 'Турция' },
    ],
  },
  {
    label: 'Европа',
    countries: [
      { code: 'BE', name: 'Бельгия' },
      { code: 'GB', name: 'Великобритания' },
      { code: 'HU', name: 'Венгрия' },
      { code: 'DE', name: 'Германия' },
      { code: 'DK', name: 'Дания' },
      { code: 'ES', name: 'Испания' },
      { code: 'IT', name: 'Италия' },
      { code: 'LT', name: 'Литва' },
      { code: 'NL', name: 'Нидерланды' },
      { code: 'NO', name: 'Норвегия' },
      { code: 'PL', name: 'Польша' },
      { code: 'PT', name: 'Португалия' },
      { code: 'RO', name: 'Румыния' },
      { code: 'RS', name: 'Сербия' },
      { code: 'SK', name: 'Словакия' },
      { code: 'FR', name: 'Франция' },
      { code: 'HR', name: 'Хорватия' },
      { code: 'SE', name: 'Швеция' },
    ],
  },
  {
    label: 'Азиатско-Тихоокеанский регион',
    countries: [
      { code: 'AU', name: 'Австралия' },
      { code: 'MY', name: 'Малайзия' },
      { code: 'SG', name: 'Сингапур' },
      { code: 'PH', name: 'Филиппины' },
      { code: 'JP', name: 'Япония' },
    ],
  },
];

// Special entry for worldwide
const WORLDWIDE = { code: 'all', name: 'Все регионы (Мир)' };

export { REGIONS, WORLDWIDE };